import * as React from "react";

import { List, ListItem, ListItemIcon, ListItemText, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpIcon from "@mui/icons-material/Help";
import InfoIcon from "@mui/icons-material/Info";

import { prettyName } from "../common/prettyName";
import { filters } from "../assets/filters";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))
(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#353d42',
    color: 'ghostwhite',
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(15),
    border: '1px solid dimgrey',
    borderRadius: "0px",
  },
}));

const SudFeatureList = ({ properties }) => {

  const renderInfo = (f) => {
    return (
      <StyledTooltip title={f.description}>
        <InfoIcon />
      </StyledTooltip>
    )
  }

  const renderIcon = (f) => {
    if (properties[f.name] === "Y") {
      return (<CheckCircleIcon />)
    }

    if (properties[f.name] === "N") {
      return (<CancelIcon />)
    }

    return (<HelpIcon />)
  }

  const renderProp = (f) => {
    return (
      <ListItem
        key={f.name}
        disablePadding
        dense
        disabled={properties[f.name] !== "Y"}>
        <div>
          <ListItemIcon>
            {renderIcon(f)}
            {renderInfo(f)}
          </ListItemIcon>
        </div>
        <ListItemText>
          {prettyName(f.name)}
        </ListItemText>
      </ListItem>
    )  
  }

  return (
    <List dense disablePadding>
      {filters.map(renderProp)}
    </List>
  );
};

export default SudFeatureList;
